import ButtonExample from "./examples/Button.Example";
import ClipboardButtonExample from "./examples/ClipboardButton.Example";
import MenuButtonExample from "./examples/MenuButton.Example";
import SplitButtonExample from "./examples/SplitButton.Example";

export default [
    {
        title: "Basic buttons",
        component: ButtonExample,
        code: require("!raw-loader!./examples/Button.Example.tsx"),
        stretchContainer: true,
    },
    {
        title: "Menu button",
        component: MenuButtonExample,
        code: require("!raw-loader!./examples/MenuButton.Example.tsx"),
    },
    {
        title: "Split button",
        component: SplitButtonExample,
        code: require("!raw-loader!./examples/SplitButton.Example.tsx"),
    },
    {
        title: "Clipboard button",
        component: ClipboardButtonExample,
        code: require("!raw-loader!./examples/ClipboardButton.Example.tsx"),
    },
];
